import { getUsers } from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

let UsersNew = {

  render: async () => {

    const isXBET = true;
      // window.location.host === 'm.xbet365.co' ||
      // window.location.host === 'xbet365.co';

    let users = await getUsers();
    let myUser = users.data.user;
    let childrenUsers = users.data.children_users;
    let usersView = ``;
    let myUserView = ``;
    let eur = 0;
    let mkd = 0;
    let usd = 0;
    let lek = 0;
    if (myUser.total_coins.includes('|')) {
      const allCurrencies = myUser.total_coins.split('|');


      allCurrencies.forEach(currency => {
        const id = currency.split(';')[0].split('.')[0];
        const value = currency.split(';')[1];
        if (id == 1) eur += parseFloat(value);
        if (id == 2) lek += parseFloat(value);
        if (id == 3) usd += parseFloat(value);
        if (id == 6) mkd += parseFloat(value);
      });
    }
    else {
      if (myUser.currency_id) {
        if (myUser.currency_id == 1) eur += parseFloat(myUser.total_coins);
        if (myUser.currency_id == 2) lek += parseFloat(myUser.total_coins);
        if (myUser.currency_id == 3) mkd += parseFloat(myUser.total_coins);
      } else {
        const value = myUser.total_coins.split(';')[1];

        const id = myUser.total_coins.split(';')[0].split('.')[0];

        if (id == 1) eur += parseFloat(value);
        if (id == 2) lek += parseFloat(value);
        if (id == 3) usd += parseFloat(value);
        if (id == 6) mkd += parseFloat(value);
      }

    }
    myUserView = myUserView + `
      <tr>
        <td>${'Balanca'}</td>
        <td class="text-right">${Utils.formatNumber(eur)}</td>
        <td class="text-right">${Utils.formatNumber(lek)}</td>
        ${
          isXBET ?
            `<td class="text-right">${Utils.formatNumber(usd)}</td>`:
            `<td class="text-right">${Utils.formatNumber(mkd)}</td>`
        }
      </tr>`;


    const uniqueChildrenUsers = [
      ...new Set(childrenUsers.map((item) => item.username)),
    ].sort();

    uniqueChildrenUsers.forEach((childrenUser) => {
      const users = childrenUsers.filter(a => a.username == childrenUser);

      usersView = usersView + `
      <tr data-id="${users[0].id}" class="${users[0].state == 1 ? 'notBlocked' : 'blocked' }" ${users[0].state == 1 ? '' : 'hidden'}>
        <td>${childrenUser}</td>
        <td class="text-right">${Utils.formatNumber(users.filter(a => a.currency == "EURO")[0] ? users.filter(a => a.currency == "EURO")[0].total_coins : 0)}</td>
        <td class="text-right">${Utils.formatNumber(users.filter(a => a.currency == "LEK")[0] ? users.filter(a => a.currency == "LEK")[0].total_coins : 0)}</td>
        ${
          isXBET ?
          `<td class="text-right">${Utils.formatNumber(users.filter(a => a.currency == "USD")[0] ? users.filter(a => a.currency == "USD")[0].total_coins : 0)}</td>`:
          `<td class="text-right">${Utils.formatNumber(users.filter(a => a.currency == "MKD")[0] ? users.filter(a => a.currency == "MKD")[0].total_coins : 0)}</td>`
        }
      </tr>`;

    });

    let title = '';
    switch (localStorage.getItem('role')) {
      case 'Administrator':
        title = _t('Lista e Supermenaxhereve');
        break;
      case 'Supermanager':
        title = _t('Lista e Menaxhereve');
        break;
      case 'Manager':
        title = _t('Lista e Agjenteve');
        break;
      default:
        title = _t('Lista e Perdoruesve');
    }

    let view =  /*html*/`
          <div class="usersHeader">
            <a class="backBtn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
            </a>
            <span>${title}</span>
          </div>
          <div class="page-content-wrapper">
            <table class="page-table" id="balance-table">
              <thead>
                <tr class="table-title">
                  <td colspan="4">${_t('Gjendja ime')}</td>
                </tr>
                <tr>
                  <th></th>
                  <th class="text-right" width="80">EUR</th>
                  <th class="text-right" width="80">LEK</th>
                  ${
                    isXBET ?
                      `<th class="text-right" width="80">USD</th>`:
                      `<th class="text-right" width="80">MKD</th>`
                  }                  
                  
                </tr>
              </thead>
              <tbody>
                ${myUserView}
              </tbody>
            <table>

            <table class="page-table" id="users-table">
              <thead>
                <tr class="table-title">
                  <td colspan="4" class="text-center">
                    <span class="title-red-light"></span>
                    ${_t('Gjendja e secilit klient')}
                    <span class="title-green-light"></span>
                  </td>
                </tr>
                <tr class="table-filter">
                  <td colspan="4" class="text-center">
                    <button class="table-filter-button active" data-value="1">${_t('Ne Pune')}</button>
                    <button class="table-filter-button" data-value="0">${_t('Bllokuar')}</button>
                  </td>
                </tr>
                <tr>
                  <th></th>
                  <th class="text-right" width="80">EUR</th>
                  <th class="text-right" width="80">LEK</th>
                  ${
                    isXBET ?
                      `<th class="text-right" width="80">USD</th>`:
                      `<th class="text-right" width="80">MKD</th>`
                  }
                </tr>
              </thead>
              <tbody>
                ${usersView}
              </tbody>
            <table>
          </div>
       `
    return view
  }
  , after_render: async () => {

    $('#users-table tbody tr').unbind('click');
    $('#users-table tbody tr').on('click', function(e) {
      const id = $(this).attr('data-id');
      window.location.href = '#/userprofile/' + id;
    });

    $('body').on('click', '#users-table .table-filter-button', function(e){
      $(e.currentTarget).parent().children('button').removeClass('active');
      $(e.currentTarget).addClass('active');

      const showBlocked = $(e.currentTarget).attr('data-value') === '0';
      $('#users-table tbody tr').each(function(i, item){
        if (showBlocked) {
          if ($(item).hasClass('notBlocked')) {
            $(item).attr('hidden', true);
          } else {
            $(item).removeAttr('hidden')
          }
        } else {
          if ($(item).hasClass('notBlocked')) {
            $(item).removeAttr('hidden')
          } else {
            $(item).attr('hidden', true);
          }
        }
      });
    });
  },
  hideFooterCasino: true

}

export default UsersNew;